interface IProps {
    label: string;
    number: number;
}

/**
 * A single 30-day stat (scopes / pages / clauses) for the chat-off home.
 * Left-aligned, indigo value for brand authority, tabular figures so a row of
 * tiles aligns to the digit. Surface tokens (not a baked-in gradient) keep it
 * theme- and dark-mode-correct.
 */
export const MetricsTile = ({ label, number }: IProps) => {
    return (
        <div className="bg-card flex flex-col gap-1 rounded-xl border px-5 py-4">
            <span className="text-primary font-heading text-2xl leading-none font-semibold tabular-nums sm:text-3xl">
                {number.toLocaleString()}
            </span>
            <span className="text-muted-foreground text-xs font-medium tracking-wide">
                {label}
            </span>
        </div>
    );
};
